import { LongArrowLeftIcon } from 'components/icons';
import styled from 'styled-components';

export default styled(LongArrowLeftIcon)`
  transform: rotateY(180deg);
`;
